import { DailyLoadStatusType } from './DailyLoadStatusType';

export const DailyLoadStatusTypes:Map<string, string> = new Map([
  [DailyLoadStatusType.FILES_EXPECTED, 'Expected Time Is XX:XX'],
  [DailyLoadStatusType.FILES_RECEIVED, 'Files Received'],
  [DailyLoadStatusType.FILES_RECEIVED_LATE, 'Files Received Late'],
  [DailyLoadStatusType.PAST_DUE, 'Files Past Due (XX:XX)'],
  [DailyLoadStatusType.SOME_FILES_RECEIVED, 'Full Set of Files Not Received Yet'],
]);

export default DailyLoadStatusTypes;
